export default __webpack_public_path__ + "static/media/complementary--trucks-buses-trailers--g1.af473f66.png";